import { Flex, Grid } from '@chakra-ui/react';
import Cards from './Cards';
import FormList from './FormList';
import FormSubmitionsChart from './FormSubmitionsChart';

const Homepage = () => (
  <Flex flexDirection="column" py="4">
    <Cards />
    <Grid
      templateColumns={{ sm: '1fr', lg: '2fr 1fr' }}
      templateRows={{ lg: 'repeat(2, auto)' }}
      gap="20px"
    >
      <FormSubmitionsChart />
      <FormList />
    </Grid>
  </Flex>
);
export default Homepage;
